import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthShell } from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login, apiError } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email || "");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const u = await login(email, password);
      navigate(u.role === "admin" ? "/admin" : "/coach");
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <AuthShell
      hideLogo
      title="👋 Hey, it's Mira! Welcome back!"
      subtitle="Log in to your coaching dashboard"
      footer={<>No account? <Link to="/register" className="text-emerald-400 hover:underline">Get started free</Link></>}
    >
      <form onSubmit={submit} className="space-y-4">
        <div className="space-y-1.5">
          <Label>Email</Label>
          <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="bg-slate-950 border-slate-700 h-11" />
        </div>
        <div className="space-y-1.5">
          <Label>Password</Label>
          <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="bg-slate-950 border-slate-700 h-11" />
        </div>
        {error && <p data-testid="login-error" className="text-sm text-rose-400">{error}</p>}
        <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full h-11 bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-semibold">
          {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Log in"}
        </Button>
        <div className="text-center">
          <Link to="/forgot-password" className="text-xs text-slate-400 hover:text-emerald-400">Forgot password?</Link>
        </div>
      </form>
    </AuthShell>
  );
}
